<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iHbnAg/media/FC-9781035800568.jpg?1695340671822" alt="This image is the cover for the book Marelle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marelle
      </h1>
      <p class="bookDescription body article font2">
        <p>The nature of war is that there is no normal; emotions are always running on the surface; fear, hope, sadness and love can all manifest themselves in an instant. In this setting, four central characters embark upon a daring and extremely dangerous journey through war torn France in 1944. Two French orphaned children have no idea how they will reach what they believe to be their only surviving family. Meanwhile, two Allied prisoners of war escape their captivity, but behind enemy lines they are uncertain about their survival and their ability to get back behind Allied lines. They each carry a burden of their own personal heart-breaking tragedy as fate brings them together. The sadness and despair from the loss felt by each of them must be overcome if they are to survive. Survival, however, is not guaranteed as each step they take on the journey is fraught with danger. They soon realise that love and friendship are the most important ingredients to help them reach their personal objectives. Despite the perils they face they demonstrate courage and determination and never lose hope, because as each day passes and with each crisis they face, the bond between the two vulnerable children and the soldiers grows stronger.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael G Franks
      </h2>
      
      <p class="authorDescription body article">Michael Franks is a writer who enjoys building stories that involve a wide range of human emotions. He has a wealth of life experience having spent many years in military service around the world and holds a BSc in Psychology. His aim in his writing is to touch the senses of the reader and enable them to experience the emotions of the characters in the story.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f73cfa2e